import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useState 
} from "react"
import DEFAULT_OPERATIONS from "./useInformationForm.gql"

export const useVirtualAppointments = (props) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)
  const {
    cancelAppointmentsMutation, getAppointmentsMutation 
  } = operations

  const [isActive, setIsActive] = useState(0)
  const [virType, setVirType] = useState(-1)
  const [completeStep1, setCompleteStep1] = useState(false)
  const [completeStep2, setCompleteStep2] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  const [canceldialog, setCanceldialog] = useState(false)
  const [timeDiff, setTimeDiff] = useState(0)
  const monthlist = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Spt",
    "Oct",
    "Nov",
    "Dec",
  ]
  const timezonedata = [
    {
      label: "(GMT-10:00) Hawaii Time", value: "HawaiiTime", timediff: -5 
    },
    {
      label: "(GMT-8:00) Alaska Time", value: "AlaskaTime", timediff: -3 
    },
    {
      label: "(GMT-7:00) Pacific Time",
      value: "PacificTime",
      timediff: -2,
    },
    {
      label: "(GMT-6:00) Mountain Time",
      value: "MountainTime",
      timediff: -1,
    },
    {
      label: "(GMT-7:00) Arizona Time",
      value: "ArizonaTime",
      timediff: -2,
    },
    {
      label: "(GMT-5:00) Central Time", value: "CentralTime", timediff: 0 
    },
    {
      label: "(GMT-4:00) Eastern Time", value: "EasternTime", timediff: 1 
    },
  ]
  const [appointmentData, setAppointmentData] = useState({
    type: "",
    date: monthlist[getdate(1).getMonth()] + " " + getdate(1).getDate(),
    time: "",
    week: getweek(getdate(1)),
    timezone: "CentralTime",
  })
  // 选择时区
  const handleChange = useCallback(() => {
    const appointmentDataTemp = appointmentData

    appointmentDataTemp.timezone = props.current.value
    setTimeDiff(timezonedata.find((item) => item.value == props.current.value)
      .timediff)
    setAppointmentData(Object.assign({}, appointmentData, {
      appointmentData: appointmentDataTemp,
    }))
  }, [])
  // 选择日期
  const changeDate = useCallback((index, w, d) => {
    setIsActive(index)
    const appointmentDataTemp = appointmentData

    appointmentDataTemp.week = w
    appointmentDataTemp.date = d
    setAppointmentData(Object.assign({}, appointmentData, {
      appointmentData: appointmentDataTemp,
    }))
  }, [])
  // 选择时间
  const changeTime = useCallback((item) => {
    const appointmentDataTemp = appointmentData

    appointmentDataTemp.time = item
    setAppointmentData(Object.assign({}, appointmentData, {
      appointmentData: appointmentDataTemp,
    }))
    setCompleteStep1(true)
  }, [])
  // 选择类型
  const SelectVirType = useCallback(
    (title, index) => {
      const appointmentDataTemp = appointmentData

      if (appointmentDataTemp.type == title) {
        appointmentDataTemp.type = ""
        setVirType(-1)
      } else {
        appointmentDataTemp.type = title
        setVirType(index)
      }

      setAppointmentData(Object.assign({}, appointmentData, {
        appointmentData: appointmentDataTemp,
      }))
    },
    [appointmentData]
  )
  const reelect = useCallback(() => {
    setCompleteStep1(false)
  }, [])

  // 根据日期获取星期
  function getweek(now) {
    const day = now.getDay()
    const weeks = new Array(
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    )
    const week = weeks[day]

    return week
  }

  // 根据传入的count计算count天之后的日期
  function getdate(count) {
    return new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * count)
  }

  function getweektip(w, i) {
    let tip = ""

    if (w == "Monday") {
      if (i < 7) {
        tip = "Next Week"
      }

      if (i >= 7 && i <= 14) {
        tip = "In 2 weeks"
      }

      if (i >= 14 && i <= 21) {
        tip = "In 3 weeks"
      }

      if (i >= 24) {
        tip = "In 4 weeks"
      }
    }

    return tip
  }

  const [
    cancelAppointments,
    {
      data, error: cancelAppointmentsMutationError 
    },
  ] = useMutation(cancelAppointmentsMutation, {
    fetchPolicy: "no-cache",
  })

  const canCelSubmit = useCallback(
    async (id) => {
      try {
        await cancelAppointments({
          variables: {
            id: Number(id) 
          },
        })
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      }
    },
    [data]
  )

  const canCelhandle = useCallback(() => {
    setCanceldialog((canceldialog) => !canceldialog)
  }, [setCanceldialog])

  const errors = useMemo(
    () => new Map([
      [
        "cancelAppointmentsMutationError",
        cancelAppointmentsMutationError,
      ],
    ]),
    [cancelAppointmentsMutationError]
  )

  return {
    handleChange,
    changeDate,
    isActive,
    appointmentData,
    SelectVirType,
    virType,
    changeTime,
    completeStep1,
    completeStep2,
    setCompleteStep1,
    setCompleteStep2,
    getweek,
    getdate,
    getweektip,
    monthlist,
    setIsUpdate,
    isUpdate,
    reelect,
    timezonedata,
    timeDiff,
    canCelSubmit,
    canCelhandle,
    canceldialog,
    errors,
    getAppointmentsMutation,
    response: data && data.cancelAppointments,
  }
}
